import { render, staticRenderFns } from "./HeadingBrand.vue?vue&type=template&id=aba9508e"
import script from "./HeadingBrand.vue?vue&type=script&lang=js"
export * from "./HeadingBrand.vue?vue&type=script&lang=js"
import style0 from "./HeadingBrand.vue?vue&type=style&index=0&id=aba9508e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports